import { render, staticRenderFns } from "./VeJwKsJiankaoList.vue?vue&type=template&id=8f981bac&scoped=true"
import script from "./VeJwKsJiankaoList.vue?vue&type=script&lang=js"
export * from "./VeJwKsJiankaoList.vue?vue&type=script&lang=js"
import style0 from "./VeJwKsJiankaoList.vue?vue&type=style&index=0&id=8f981bac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f981bac",
  null
  
)

export default component.exports